import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import axios from 'axios';
import apiUrl from '../constants.js';

const useStyles = makeStyles (() => ({
  imgDiv: {
    width: 300,
    height: 300,
  },
  maxWidth300: {
    maxWidth: '300px'
  }
}));

const YCard = ({card, setRows, setLoading, handleModalColumnEdit}) => {
  const classes = useStyles();

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  const widthSizes = [];
  widthSizes[12] = "100%";
  widthSizes[8] = "66,66%";
  widthSizes[6] = "50%";
  widthSizes[4] = "33,33%";
  widthSizes[3] = "25%";

  const remove = (card) => {
    if(window.confirm('¿Está seguro de eliminar este STORE BOX?')){
      setLoading(true);
      let url = apiUrl+"v1/column/delete/"+card.id+"?id_user="+userId;
      axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': token,
          }
        }
      )
      .then(function (response) {
        setRows(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
    }
  };

  return (
    <div >
      <p className={classes.maxWidth300}>
        <strong>Título: </strong> {card.title}<br/>
        <strong>Descripción: </strong> {card.description}<br/>
        <strong>Tamaño: </strong> {widthSizes[card.width]}<br/>
        <strong>URL: </strong> <a href={card.url} target="_blank">{card.url}</a>
      </p>

      <p>
        <IconButton
          aria-label="Eliminar"
          onClick={() => remove(card)}>
          <DeleteIcon />
        </IconButton>

        <IconButton
          aria-label="Editar"
          onClick={() => handleModalColumnEdit(true, card)}>
          <EditIcon />
        </IconButton>
      </p>

      <div className={classes.imgDiv}>
        <img className="img-structure-col" src={card.url_prefix+"/"+card.image_1} />
      </div>
    </div>
  );
};

export default YCard;
